define(["mw-log/impl/Modes"], function (Modes) {

    var utils = {};

    utils.objectValues = function (object) {
        var arr = [];
        for (var key in object) {
            if (object.hasOwnProperty(key)) {
                arr.push(object[key]);
            }
        }
        return arr;
    };

    utils.makeReadOnlyProperty = function (object, key, value) {
        Object.defineProperty(object, key, {
            value: value,
            writable: false
        });
    };

    utils.execCallbacks = function (callbacks, message) {
        var cbList = utils.objectValues(callbacks);
        for (var i in cbList) {
            cbList[i](message);
        }
    };

    utils.currentTimeString = function () {
        var now = new Date();
        return now.toLocaleTimeString('en-US', { hour12: false,
            hour: "numeric",
            minute: "numeric",
            second: "numeric" }) + "." + now.getTime() % 1000;
    };

    utils.printToConsole = function (method, args, mode) {
        // check for production mode
        // in production mode, still show errors
        if (mode !== Modes.PRODUCTION || method === "error") {
            console[method].apply(console, args);
        }
    };
    return utils;
});
//# sourceMappingURL=LogUtils.js.map
